import React, { useCallback, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { ContentFrame, ScreenContainer } from '@pinwheel/origami';
import useFireClientEvent from '../hooks/useFireClientEvent';
import useLinkNavigate from '../hooks/useLinkNavigate';
import { SwitchConfirmation as SwitchConfirmationView, RemainderSwitchConfirmation, } from '../views/AmountSelection';
import { selectLinkParams } from '../state/slices/slice-link-params';
import { selectLoadedPlatform } from '../state/slices/slice-link-api';
import { selectHistory } from '../state/history';
import ModalHeader from '../components/ModalHeader';
import useAmountOrPercentageSupported from '../views/AmountSelection/FullSwitchAndMore/hooks/useAmountOrPercentageSupported';
var SwitchConfirmation = function () {
    var fireClientEvent = useFireClientEvent();
    var navigate = useLinkNavigate();
    var linkParams = useSelector(selectLinkParams);
    var loadedPlatform = useSelector(selectLoadedPlatform);
    var history = useSelector(selectHistory);
    var linkTokenPayload = linkParams.linkTokenPayload, experiments = linkParams.experiments;
    var disableDirectDepositSplitting = linkTokenPayload.disableDirectDepositSplitting;
    var amountOrPercentageSwitchSupported = useAmountOrPercentageSupported();
    var hideBackButton = useMemo(function () {
        // If the previous screen was login, going back will not work
        return history.length > 1 && history[1].pathname === '/link-api/login';
    }, [history]);
    var handleContinue = useCallback(function () {
        navigate('/link-api/dds');
    }, [navigate]);
    useEffect(function () {
        fireClientEvent('input_required');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var ConfirmationComponent = (disableDirectDepositSplitting || !amountOrPercentageSwitchSupported) &&
        !(loadedPlatform === null || loadedPlatform === void 0 ? void 0 : loadedPlatform.fullSwitchSupported) &&
        !experiments.confirmationScreenEnabled
        ? RemainderSwitchConfirmation
        : SwitchConfirmationView;
    return (React.createElement(ScreenContainer, null,
        React.createElement(ModalHeader, { showPlatformLogo: true, hideBackButton: hideBackButton }),
        React.createElement(ContentFrame, null,
            React.createElement(ConfirmationComponent, { onContinue: handleContinue }))));
};
export default SwitchConfirmation;
